import React, { useEffect } from 'react'
import { useState } from 'react'

function KeyValueFields({ field, setFields }) {

    const defaultObject = {
        'key': '',
        'value': ''
    };

    const [options, setOptions] = useState(
        field.options && field.options.length > 0 
            ? field.options 
            : [defaultObject]
    )

    useEffect(() => {
        setFields(oldFields => {
            const newFields = [...oldFields];

            newFields.find(n => n.id == field.id).options = options;

            return newFields;
        })
    }, [options])

    const addToOptions = () => {
        setOptions(prevOptions => [...prevOptions, defaultObject])
    }

    const clearOptions = () => {
        setOptions([defaultObject])
    }

    const removeOption = (index) => {
        let newArr = options.filter((_, i) => i != index);
        if (newArr.length == 0) {
            newArr = [defaultObject]
        }
        setOptions(newArr);
    }

    const updateKey = (index, newKey) => {
        setOptions(oldOptions => {
            const newOptions = [...oldOptions];
            newOptions[index].key = newKey;
            return newOptions;
        })
    }

    const updateValue = (index, newvalue) => {
        setOptions(oldOptions => {
            const newOptions = [...oldOptions];
            newOptions[index].value = newvalue;
            return newOptions;
        })
    }


    return (
        <div>
            <div className=' bg-slate-200'>
                <button onClick={addToOptions}>Add</button>
                <button onClick={clearOptions}>Clear</button>
            </div>

            <div>
                <table>
                    <tr>
                        <td>Label</td>
                        <td>Value</td>
                        <td>Action</td>
                    </tr>
                    {
                        options.map((option, index) =>
                            <tr key={index}>
                                {/* {option.key} */}
                                <td>
                                    <input type="text" className=' mb-4 outline-none border-b-2 border-slate-300 focus:border-green-700' value={option.key} onChange={(e) => updateKey(index, e.target.value)} />
                                </td>
                                <td>
                                    <input type="text" className=' mx-5 mb-4 outline-none border-b-2 border-slate-300 focus:border-green-700' value={option.value} onChange={(e) => updateValue(index, e.target.value)} />
                                </td>
                                <td>
                                    <button className=' mb-4' onClick={() => removeOption(index)}>Delete</button>
                                </td>
                            </tr>)
                    }
                </table>
            </div>

        </div>
    )
}

export default KeyValueFields